import { configureStore } from "@reduxjs/toolkit";
import reducer from "./features";
// import { configureStore } from "@reduxjs/toolkit";
// import dataReducer from "./features/seller/dataSlice";

// import logger from 'redux-logger';
// import dataReducer from "./seller/DataSlice.jsx";

// Configure the store so that RTK's serializableCheck ignores the paths that legitimately contain
// Date objects (calendar events). This prevents the "A non-serializable value was detected ..."
// warnings / errors that appear after the first drag-and-drop.
const store = configureStore({
  reducer,
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger)
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // These slices/paths intentionally contain Date instances (start, end).
        ignoredPaths: [
          'appointments.list',
          'appointments.draggedAppointment',
        ],
        // Consider Date objects safe for serialization checks to avoid warnings
        isSerializable: (value: any) => {
          // Treat Dates as serializable; rely on default check for others
          if (value instanceof Date) return true;
          const type = typeof value;
          return (
            type === 'undefined' ||
            type === 'boolean' ||
            type === 'number' ||
            type === 'string' ||
            value === null ||
            Array.isArray(value) ||
            (type === 'object' && Object.getPrototypeOf(value) === Object.prototype)
          );
        },
      },
    }),
});

export default store;
